// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterable-table-container .header-row {
  margin-top: 6px;
}
.filterable-table-container .header-row .exact-filters {
  margin-top: 20px;
}
.filterable-table-container .header-row .record-count {
  padding-top: 7px;
}
.filterable-table-container table.filterable-table thead tr th {
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}
.filterable-table-container table.filterable-table thead tr th span.fa {
  padding-left: 8px;
  color: #aaa;
}
.filterable-table-container table.filterable-table tfoot tr td {
  font-weight: 700;
}
.filterable-table-container .filter-container {
  position: relative;
}
.filterable-table-container .filter-container .filter-input,
.filterable-table-container .filter-container .page-size {
  width: 185px;
  display: inline;
}
.filterable-table-container .clear-filter {
  position: absolute;
  right: 5px;
  top: 1px;
}
.filterable-table-container span.sortable,
.filterable-table-container span.filterable {
  cursor: pointer;
}
.filterable-table-container span.filterable {
  border-bottom: 1px solid #91c1ff;
}
.filterable-table-container ul.pagination li a {
  -webkit-user-select: none;
          user-select: none;
}
.filterable-table-container ul.pagination li:not(.disabled) a {
  cursor: pointer;
}
.filterable-table-container span.empty {
  font-style: italic;
  color: #999;
}
.filterable-table-container .filter-item {
  border: 1px solid #ccc;
  border-radius: 1px;
  display: inline-block;
  margin-right: 15px;
}
.filterable-table-container .filter-item .filter-item-title {
  background-color: #2f6e9b;
  border-radius: 1px;
  color: #fff;
}
.filterable-table-container .filter-item .filter-item-title .filter-item-remove {
  color: #fff;
  font-weight: 700;
  -webkit-user-select: none;
          user-select: none;
  padding-right: 10px;
  cursor: pointer;
}
.filterable-table-container .filter-item .filter-item-title,
.filterable-table-container .filter-item .filter-item-value {
  padding: 5px 10px;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-filterable-table/dist/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;;EAEE,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,iBAAiB;EACjB,qBAAqB;AACvB","sourcesContent":[".filterable-table-container .header-row {\n  margin-top: 6px;\n}\n.filterable-table-container .header-row .exact-filters {\n  margin-top: 20px;\n}\n.filterable-table-container .header-row .record-count {\n  padding-top: 7px;\n}\n.filterable-table-container table.filterable-table thead tr th {\n  white-space: nowrap;\n  user-select: none;\n}\n.filterable-table-container table.filterable-table thead tr th span.fa {\n  padding-left: 8px;\n  color: #aaa;\n}\n.filterable-table-container table.filterable-table tfoot tr td {\n  font-weight: 700;\n}\n.filterable-table-container .filter-container {\n  position: relative;\n}\n.filterable-table-container .filter-container .filter-input,\n.filterable-table-container .filter-container .page-size {\n  width: 185px;\n  display: inline;\n}\n.filterable-table-container .clear-filter {\n  position: absolute;\n  right: 5px;\n  top: 1px;\n}\n.filterable-table-container span.sortable,\n.filterable-table-container span.filterable {\n  cursor: pointer;\n}\n.filterable-table-container span.filterable {\n  border-bottom: 1px solid #91c1ff;\n}\n.filterable-table-container ul.pagination li a {\n  user-select: none;\n}\n.filterable-table-container ul.pagination li:not(.disabled) a {\n  cursor: pointer;\n}\n.filterable-table-container span.empty {\n  font-style: italic;\n  color: #999;\n}\n.filterable-table-container .filter-item {\n  border: 1px solid #ccc;\n  border-radius: 1px;\n  display: inline-block;\n  margin-right: 15px;\n}\n.filterable-table-container .filter-item .filter-item-title {\n  background-color: #2f6e9b;\n  border-radius: 1px;\n  color: #fff;\n}\n.filterable-table-container .filter-item .filter-item-title .filter-item-remove {\n  color: #fff;\n  font-weight: 700;\n  user-select: none;\n  padding-right: 10px;\n  cursor: pointer;\n}\n.filterable-table-container .filter-item .filter-item-title,\n.filterable-table-container .filter-item .filter-item-value {\n  padding: 5px 10px;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
